import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from '@saucelabs/sl-component-form';
import { ListGroup, ListGroupItem } from '@saucelabs/sl-component-list-group';
import fuzzyFilterFactory from 'react-fuzzy-filter';

import Styles from './ChangeLanguageList.styles';

const { InputFilter, FilterResults } = fuzzyFilterFactory();

const searchConfig = {
  keys: ['label'],
  threshold: 0.15,
};

const ChangeLanguageList = ({ items, onClick }) => (
  <div className={Styles.default}>
    <FormGroup>
      <InputFilter
        inputProps={{
          className: 'form-control',
          placeholder: 'Search languages',
        }}
      />
    </FormGroup>
    <FilterResults
      fuseConfig={searchConfig}
      items={items}
    >
      {(filteredItems) => (
        <ListGroup>
          {filteredItems.map((language) => (
            <ListGroupItem
              key={language.id}
              onClick={() => onClick(language)}
            >
              {language.label}
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </FilterResults>
  </div>
);

ChangeLanguageList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ChangeLanguageList;
